var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item shadowless" }, [
    _c(
      "div",
      {
        staticClass: "consignment-main-data",
        class: [_vm.showInvestors ? "has-investors" : "hasnt-investors"],
      },
      [
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "has-text-weight-bold" }, [
            _vm._v(_vm._s(_vm.consignmentDictionary.createdAt)),
          ]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.formatDate(
                  _vm.consignmentData.createdAt,
                  "DD/MM/YYYY HH:mm:ss"
                )
              )
            ),
          ]),
        ]),
        _vm.showInvestors
          ? _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "has-text-weight-bold" }, [
                _vm._v(_vm._s(_vm.consignmentDictionary.investor)),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.investor.name))]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "has-text-weight-bold" }, [
            _vm._v(
              _vm._s(
                _vm.consignmentDictionary.totalSecondaryCurrencyConsignedAmount
              )
            ),
          ]),
          _c("span", [
            _vm._v(
              "$ " +
                _vm._s(
                  _vm.formatNumber(
                    _vm.consignmentData.totalSecondaryCurrencyConsignedAmount
                  )
                )
            ),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "has-text-weight-bold" }, [
            _vm._v(_vm._s(_vm.consignmentDictionary.duesNumber)),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.consignmentData.consignedPayments.length)),
          ]),
        ]),
        _c("div", { staticClass: "button-item" }, [
          _c(
            "a",
            {
              attrs: { id: `copy-button-${_vm.consignmentData._id}` },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.copyToClipBoard()
                },
              },
            },
            [_vm._m(0)]
          ),
          _c(
            "a",
            {
              attrs: { href: "javascript:void(0);" },
              on: {
                click: function ($event) {
                  return _vm.setCurrentExtendedConsignment(_vm.consignmentIndex)
                },
              },
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.currentExtendedConsignment === _vm.consignmentIndex
                      ? "Ocultar "
                      : "Ver info "
                  ),
                },
              }),
              _c("span", {
                staticClass: "fa fa-chevron-down transition-slow",
                class: {
                  rotate:
                    _vm.currentExtendedConsignment === _vm.consignmentIndex,
                },
              }),
            ]
          ),
        ]),
      ]
    ),
    _vm.showInvestors
      ? _c(
          "div",
          {
            staticClass: "consignment-details-data transition-slow",
            class: {
              hide: _vm.currentExtendedConsignment !== _vm.consignmentIndex,
            },
          },
          [
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "has-text-weight-bold" }, [
                _vm._v(_vm._s(_vm.consignmentDictionary.bankAccountType)),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.investor.bankAccount.type))]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "has-text-weight-bold" }, [
                _vm._v(_vm._s(_vm.consignmentDictionary.bankAccountNumber)),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.investor.bankAccount.number))]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "has-text-weight-bold" }, [
                _vm._v(_vm._s(_vm.consignmentDictionary.bankName)),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.investor.bankAccount.bankName))]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-table fa-lg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }